/**
 * A deep link from another product (Trackrs's "!" links to
 * `/integrations/trackrs/attention?org=<id>`) names the company it is about. The
 * admin may be signed in with another company active, so the page has to switch
 * first — but only to a company they are a member of, and only when it is not
 * already the active one. Anything else (no param, unknown id, already active)
 * is "nothing to do", and the route renders against the current org.
 */
export function pickRequestedOrg<T extends { id: string }>(
  requested: string | null,
  activeOrgId: string | null,
  companies: ReadonlyArray<T>,
): T | null {
  const id = requested?.trim() ?? '';
  if (!id || id === activeOrgId) return null;
  return companies.find((company) => company.id === id) ?? null;
}
